import { createContext, useContext } from 'react';

// Dropdown popups (option lists, pickers, menus, calendars) get their colours from the
// CMS "Dropdown" style group, which sets --cms-dropdown-color / -bg / -hover-bg on
// `.cms-dropdown` (template) and `.cms-dropdown.cms-dropdown-<cssId>` (module). The
// popup root carries both classes, so this also works for popups rendered into
// document.body. Base styles and fallbacks live in layout.css.

export const DropdownScopeContext = createContext<string | null>(null);

export const DROPDOWN_OPTION = 'cms-dropdown-option';

/** Classes for a dropdown popup root, scoped to the module it belongs to. */
export function useDropdownClass(): string {
  const cssId = useContext(DropdownScopeContext);
  return cssId ? `cms-dropdown cms-dropdown-${cssId}` : 'cms-dropdown';
}

/** The same values for inline styles that must beat a library's own CSS. */
export const DROPDOWN_COLOR = 'var(--cms-dropdown-color, #222)';
export const DROPDOWN_BG = 'var(--cms-dropdown-bg, #fff)';
export const DROPDOWN_HOVER_BG = 'var(--cms-dropdown-hover-bg, rgba(0, 0, 0, 0.08))';

/** react-select `styles` for the menu and its options. Pair with `classNames={{ menu: () => dropdownClass }}`. */
export const dropdownSelectStyles = {
  menu: (base: any) => ({ ...base, color: DROPDOWN_COLOR, backgroundColor: DROPDOWN_BG }),
  option: (base: any, state: { isFocused: boolean; isSelected: boolean }) => ({
    ...base,
    color: 'inherit',
    backgroundColor: state.isFocused || state.isSelected ? DROPDOWN_HOVER_BG : 'transparent',
  }),
};
